var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 148,
    viewBox: "0 0 200 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    transform: "translate(-1201 -594)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150169",
    "data-name": "Rectangle 150169",
    width: 200,
    height: 148,
    transform: "translate(1201 594)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_time_management_re_tk5w_1_",
    "data-name": "undraw_time_management_re_tk5w (1)",
    transform: "translate(1271.051 594.353)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29978",
    "data-name": "Path 29978",
    d: "M450.722,659.767a.331.331,0,0,1-.332.332H262.5a.332.332,0,1,1,0-.664H450.39a.331.331,0,0,1,.332.332Z",
    transform: "translate(-326.495 -512.808)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17748",
    "data-name": "Group 17748",
    transform: "translate(-30.005 0.004)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_533",
    "data-name": "Ellipse 533",
    cx: 59.999,
    cy: 59.999,
    r: 59.999,
    transform: "translate(0 12.799)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29979",
    "data-name": "Path 29979",
    d: "M459.418,261.519a51.556,51.556,0,0,1-20.838,41.444c-.433.324-.873.639-1.317.946a51.636,51.636,0,0,1-58.944,0c-.444-.307-.885-.622-1.317-.946a51.633,51.633,0,0,1,0-82.888c.433-.324.873-.639,1.317-.946a51.636,51.636,0,0,1,58.944,0c.444.307.885.622,1.317.946A51.556,51.556,0,0,1,459.418,261.519Z",
    transform: "translate(-347.791 -188.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_534",
    "data-name": "Ellipse 534",
    cx: 47.162,
    cy: 47.162,
    r: 47.162,
    transform: "translate(12.837 25.636)",
    fill: "#004fe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29980",
    "data-name": "Path 29980",
    d: "M530.935,226.365c-.715,0-1.425.019-2.133.05a47.161,47.161,0,0,1-2,94.092c1.361.118,2.738.182,4.13.182a47.162,47.162,0,1,0,0-94.324Z",
    transform: "translate(-470.813 -200.598)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29981",
    "data-name": "Path 29981",
    d: "M537.7,213.892a1.538,1.538,0,0,0-1.535,1.535v6.7a1.535,1.535,0,1,0,3.07,0v-6.7A1.538,1.538,0,0,0,537.7,213.892Z",
    transform: "translate(-477.559 -191.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29982",
    "data-name": "Path 29982",
    d: "M634.13,243.93c-.433-.324-.874-.639-1.317-.946a1.534,1.534,0,0,0-1.367.667l-3.77,5.534a1.535,1.535,0,0,0,2.537,1.727l3.77-5.534A1.525,1.525,0,0,0,634.13,243.93Z",
    transform: "translate(-543.341 -212.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29983",
    "data-name": "Path 29983",
    d: "M689.2,334.331a1.533,1.533,0,0,0-2-.843L681,336.009a1.535,1.535,0,0,0,1.155,2.844l6.206-2.52a1.538,1.538,0,0,0,.843-2Z",
    transform: "translate(-581.286 -277.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29984",
    "data-name": "Path 29984",
    d: "M436.983,249.184l-3.77-5.534a1.534,1.534,0,0,0-1.367-.667c-.444.307-.885.622-1.317.946a1.525,1.525,0,0,0,.148,1.448l3.77,5.534a1.535,1.535,0,0,0,2.537-1.727Z",
    transform: "translate(-401.318 -212.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29985",
    "data-name": "Path 29985",
    d: "M377.361,336.009l-6.206-2.52A1.535,1.535,0,0,0,370,336.333l6.206,2.52a1.535,1.535,0,1,0,1.155-2.844Z",
    transform: "translate(-357.076 -277.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29986",
    "data-name": "Path 29986",
    d: "M537.7,540.892a1.537,1.537,0,0,0-1.535,1.535v6.7a1.535,1.535,0,0,0,3.07,0v-6.7A1.538,1.538,0,0,0,537.7,540.892Z",
    transform: "translate(-477.559 -427.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29987",
    "data-name": "Path 29987",
    d: "M633.982,522.182l-3.77-5.534a1.535,1.535,0,0,0-2.537,1.727l3.77,5.534a1.534,1.534,0,0,0,1.367.667c.444-.307.885-.622,1.317-.946A1.525,1.525,0,0,0,633.982,522.182Z",
    transform: "translate(-543.341 -409.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29988",
    "data-name": "Path 29988",
    d: "M688.361,439.009l-6.206-2.52A1.535,1.535,0,1,0,681,439.333l6.206,2.52a1.535,1.535,0,0,0,1.155-2.844Z",
    transform: "translate(-581.286 -352.002)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29989",
    "data-name": "Path 29989",
    d: "M436.578,516.244a1.535,1.535,0,0,0-2.132.4l-3.77,5.534a1.525,1.525,0,0,0-.148,1.448c.433.324.873.639,1.317.946a1.534,1.534,0,0,0,1.367-.667l3.77-5.534a1.534,1.534,0,0,0-.4-2.132Z",
    transform: "translate(-401.318 -409.389)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29990",
    "data-name": "Path 29990",
    d: "M378.2,437.331a1.533,1.533,0,0,0-2-.843L370,439.009a1.535,1.535,0,1,0,1.155,2.844l6.206-2.52a1.538,1.538,0,0,0,.843-2Z",
    transform: "translate(-357.076 -352.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29991",
    "data-name": "Path 29991",
    d: "M461.972,385.263a3.213,3.213,0,0,1-2.626,3.7L432.11,393.6a3.209,3.209,0,0,1-1.076-6.328l27.236-4.633a3.213,3.213,0,0,1,3.7,2.626Z",
    transform: "translate(-399.841 -313.227)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29992",
    "data-name": "Path 29992",
    d: "M566.529,415.929a2.1,2.1,0,0,1-2.96.012l-29.32-29.09a2.093,2.093,0,0,1,2.948-2.972l29.32,29.09A2.1,2.1,0,0,1,566.529,415.929Z",
    transform: "translate(-475.733 -313.718)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_535",
    "data-name": "Ellipse 535",
    cx: 3.628,
    cy: 3.628,
    r: 3.628,
    transform: "translate(56.371 69.17)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29993",
    "data-name": "Path 29993",
    d: "M371.956,143.921c-5.569,8.755-14.065,14.565-24.544,18.382a1.97,1.97,0,0,1-2.758-.4h0a17.3,17.3,0,1,1,27.54-20.954l.157.21A1.97,1.97,0,0,1,371.956,143.921Z",
    transform: "translate(-336.946 -134.031)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29994",
    "data-name": "Path 29994",
    d: "M628.429,140.953a17.3,17.3,0,1,1,27.54,20.954h0a1.97,1.97,0,0,1-2.758.4c-9.727-3.724-17.7-10.169-24.544-18.382a1.97,1.97,0,0,1-.4-2.758Z",
    transform: "translate(-543.68 -134.031)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29995",
    "data-name": "Path 29995",
    d: "M619.079,580.658a1.538,1.538,0,0,0-.59,2.089l8.858,15.829a1.535,1.535,0,0,0,2.679-1.5l-8.858-15.829A1.538,1.538,0,0,0,619.079,580.658Z",
    transform: "translate(-536.77 -455.879)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29996",
    "data-name": "Path 29996",
    d: "M430.344,581.245l-8.858,15.829a1.535,1.535,0,1,0,2.679,1.5l8.858-15.829a1.535,1.535,0,0,0-2.679-1.5Z",
    transform: "translate(-394.743 -455.876)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    cx: 4.744,
    cy: 4.744,
    r: 4.744,
    transform: "translate(87.627 137.262)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_537",
    "data-name": "Ellipse 537",
    cx: 4.744,
    cy: 4.744,
    r: 4.744,
    transform: "translate(90.976 15.868)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_538",
    "data-name": "Ellipse 538",
    cx: 4.744,
    cy: 4.744,
    r: 4.744,
    transform: "translate(54.976 4.706)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_539",
    "data-name": "Ellipse 539",
    cx: 4.744,
    cy: 4.744,
    r: 4.744,
    transform: "translate(20.651 15.31)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_540",
    "data-name": "Ellipse 540",
    cx: 4.744,
    cy: 4.744,
    r: 4.744,
    transform: "translate(23.721 137.262)",
    fill: "#e6e6e6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.57c8fad6e82e5118b21ce26accac9d84.svg";
export { ForwardRef as ReactComponent };